import type { CopilotViewContext } from '@terra/shared-dto-chat-types';
import type { Tab } from '../store/layoutStore';

type EntityView = {
  entityType: string;
  entityId: string;
};

function resolveTabEntity(tab: Tab): EntityView | undefined {
  switch (tab.type) {
    case 'finding':
      return { entityType: 'finding', entityId: tab.data.findingId };
    case 'signal':
      return { entityType: 'signal', entityId: tab.data.signalId };
    case 'endpoint':
      return { entityType: 'endpoint', entityId: tab.data.endpointId };
    case 'webpage':
      return { entityType: 'webpage', entityId: tab.data.id };
    case 'skill':
      return { entityType: 'skill', entityId: tab.data.skillId };
    case 'agent-execution':
      return { entityType: 'agentExecution', entityId: tab.data.executionId };
    case 'executions':
      return { entityType: 'execution', entityId: tab.data.threadId };
    case 'co-pilot-execution':
      return { entityType: 'coPilotExecution', entityId: tab.data.threadId };
    case 'surface-asset':
      return {
        entityType: tab.data.surfaceAssetKind,
        entityId: tab.data.entityId,
      };
    case 'ai-component':
      return { entityType: 'aiComponent', entityId: tab.data.componentId };
    default:
      return undefined;
  }
}

export function mapTabToCopilotViewContext(
  tab: Tab | undefined,
): CopilotViewContext | undefined {
  if (!tab) {
    return undefined;
  }

  const entity = resolveTabEntity(tab);
  const pathname = entity
    ? `/torch/${tab.type}/${entity.entityId}`
    : `/torch/${tab.type}`;

  return {
    pathname,
    ...(entity
      ? { entityType: entity.entityType, entityId: entity.entityId }
      : {}),
  };
}
